var homeTreatmentFilters = require('./home_treatment_filters');

$(function () {
  // Hero Slider
  var indexHeroSlider = new Swiper('#indexHeroSlider', {
    effect: 'fade',
    autoplay: {
      delay: 3500,
    },
    loop: true,
    speed: 1200,
  });

  // Treatments Slider
  var allSlides = null;
  var currentFilter = null;
  var indexTreatmentsSlider = null;

  function initAllSlides() {
    var wrapper = document.querySelector('#indexTreatmentsSlider .swiper-wrapper');
    if (!wrapper) return;

    // 保存原始 slide，並把 class 從 swiper-slide 改成 treatments-item-slide
    // 避免放進 group 後 Swiper 把 child 也當成 slide 計算
    allSlides = Array.from(wrapper.querySelectorAll(':scope > .swiper-slide'))
      .map(function (s) {
        var clone = s.cloneNode(true);
        clone.className = clone.className.replace(/\bswiper-slide\b/g, 'treatments-item-slide').trim();
        return clone;
      });
  }

  function getFilteredSlides(filterToken) {
    return homeTreatmentFilters
      .filterSlides(allSlides || [], filterToken)
      .map(function (slide) { return slide.cloneNode(true); });
  }

  // mobile：將 items 兩兩包成一個真正的 swiper-slide（group）
  function buildGroupSlides(items) {
    var groups = [];
    for (var i = 0; i < items.length; i += 2) {
      var group = document.createElement('div');
      group.className = 'swiper-slide swiper-slide-group';
      group.appendChild(items[i]);
      if (items[i + 1]) group.appendChild(items[i + 1]);
      groups.push(group);
    }
    return groups;
  }

  function rebuildSlider(filter) {
    if (!allSlides) return;

    var wrapper = document.querySelector('#indexTreatmentsSlider .swiper-wrapper');
    if (!wrapper) return;

    if (indexTreatmentsSlider) {
      indexTreatmentsSlider.destroy(true, true);
      indexTreatmentsSlider = null;
    }

    var filtered = getFilteredSlides(filter);
    wrapper.innerHTML = '';

    var isMobileNow = window.innerWidth < 640;

    if (isMobileNow) {
      // mobile：每個 swiper-slide 是 group，內含2個 treatments-item-slide
      // 一次顯示2個 group（= 4個item，上下2列）
      buildGroupSlides(filtered).forEach(function (g) {
        wrapper.appendChild(g);
      });
    } else {
      // desktop：每個 treatments-item-slide 包回 swiper-slide 直接放入
      filtered.forEach(function (item) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.appendChild(item);
        wrapper.appendChild(slide);
      });
    }

    wrapper.setAttribute('data-size', wrapper.querySelectorAll(':scope > .swiper-slide').length);

    indexTreatmentsSlider = new Swiper('#indexTreatmentsSlider', swiperConfig);
  }

  var swiperConfig = {
    // mobile: 一次顯示2個 group slide = 上下2列 = 4個item
    slidesPerView: 2,
    slidesPerGroup: 2,
    pagination: {
      el: document.querySelector('.index-treatments-pagination'),
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: document.querySelector('.index-treatments-next'),
      prevEl: document.querySelector('.index-treatments-prev'),
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      1400: {
        slidesPerView: 5,
        slidesPerGroup: 5,
      }
    },
  };

  initAllSlides();

  var isMobile = window.innerWidth < 640;

  window.addEventListener('resize', function () {
    var nowMobile = window.innerWidth < 640;
    if (nowMobile === isMobile) return;
    isMobile = nowMobile;
    if (currentFilter) rebuildSlider(currentFilter);
  });

  // 療程篩選
  var dropdown = document.getElementById('treatmentsDropdown');

  if (dropdown) {
    var filterBtn = document.getElementById('treatmentsFilterBtn');
    var dropdownList = dropdown.querySelector('.dropdown-list');
    var dropdownOption = filterBtn && filterBtn.querySelector('.dropdown-option');
    var listItems = dropdown.querySelectorAll('.dropdown-list-item');

    if (filterBtn) {
      filterBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        dropdown.classList.toggle('open');
      });
    }

    document.addEventListener('click', function () {
      dropdown.classList.remove('open');
    });

    if (dropdownList) {
      dropdownList.addEventListener('click', function (e) {
        if (e.target.closest('.dropdown-list-item')) {
          dropdown.classList.remove('open');
        }
      });
    }

    listItems.forEach(function (item) {
      item.addEventListener('click', function () {
        var filter = item.dataset.filter;
        var label = item.querySelector('.text') && item.querySelector('.text').textContent;

        listItems.forEach(function (listItem) { listItem.classList.remove('active'); });
        item.classList.add('active');
        if (dropdownOption && label) dropdownOption.textContent = label;
        dropdown.classList.remove('open');

        currentFilter = filter;
        rebuildSlider(currentFilter);
      });
    });

    currentFilter = homeTreatmentFilters.firstFilterToken(listItems);
    if (currentFilter) rebuildSlider(currentFilter);
  }

  // Doctors Slider
  var indexDoctorsSlider = new Swiper('#indexDoctorsSlider', {
    slidesPerView: 1.1,
    navigation: {
      nextEl: '.index-doctors-next',
      prevEl: '.index-doctors-prev',
    },
    breakpoints: {
      480: { slidesPerView: 1.6 },
      640: { slidesPerView: 2.3 },
      768: { slidesPerView: 3 },
      1100: { slidesPerView: 4 },
    },
  });

  // Celebrity Slider
  var indexCelebritySlider = new Swiper('#indexCelebritySlider', {
    slidesPerView: 1.1,
    navigation: {
      nextEl: '.index-celebrity-next',
      prevEl: '.index-celebrity-prev',
    },
    breakpoints: {
      480: { slidesPerView: 1.5 },
      640: { slidesPerView: 2.3 },
      1170: { slidesPerView: 3 },
      1360: { slidesPerView: 3.5 },
      2050: { slidesPerView: 4 },
    },
  });

  if (document.getElementById('aboutEquipmentSlider')) {
    new Swiper('#aboutEquipmentSlider', {
      slidesPerView: 1.4,
      centeredSlides: true,
      loop: true,
      spaceBetween: 24,
      navigation: {
        nextEl: '.about-eqpt-next',
        prevEl: '.about-eqpt-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }

});
